import { i18n } from 'localization'
import { parseDate, parsePerson } from './utils'

function medicalOpinionTypeParse(type) {
	if (type === 'Avaliação de Nexo Causal') {
		return 1
	} else if (
		type === 'Seguimento Clínico' ||
		type === 'Avaliação de Recaída' ||
		type === 'Avaliação de Transferência'
	) {
		return 2
	} else {
		return 3
	}
}

const questionLabels = {
	medicalOpinion: i18n.translate(`Medical opinion issue`),
	medicalOpinionResult: i18n.translate(`Medical opinion result`),
	mechanism: i18n.translate(
		`Is there injury mechanism characterized as accident?`
	),
	mechanismShort: i18n.translate('Injury Mec.'),
	justification: i18n.translate(`Justification`),
	isDiagnosis: i18n.translate(
		`Does the made diagnosis have causal link with the injury mechanism described?`
	),
	isSuggestedActions: i18n.translate(`Suggested actions`),
	whichActions: i18n.translate(`Which`),
	nameTriage: i18n.translate(`Name`),
	birthdayTriage: i18n.translate(`birthday date`),
	professionTriage: i18n.translate(`Profession`),
	accidentDateTriage: i18n.translate(`Accident date`),
	isAccidentDescriptionTriage: i18n.translate(`Accident description`),
	bodyPartTriage: i18n.translate(`Body part`),
	biologicRiskTriage: i18n.translate(`Is there a biological risk?`),
	biologicRiskTriageShort: i18n.translate(`Biologic Risk`),
	injuryTriage: i18n.translate(`Injury Type`),
	isPreviouslyPerformedSurgeryTriage: i18n.translate(
		`Is there any previously performed surgery?`
	),
	isPreviouslyPerformedSurgeryTriageShort: i18n.translate(`Surgery`),
	processComplexityTriage: i18n.translate(`Process complexity`),
	processDurationTriage: i18n.translate(`Duration`),
	canTransferProcessTriage: i18n.translate(`Transfer`),
	diagnosisTriage: i18n.translate(`Is there diagnosis?`),
	diagnosisTriageShort: i18n.translate(`Diagnosis`),
	isPerformedDiagnosisWithCausalLinkTriage: i18n.translate(
		`Do the performed diagnosis have causal link with the described injury mechanism?`
	),
	isPerformedDiagnosisWithCausalLinkTriageShort:
		i18n.translate(`Causal Link`),
	observationTriage: i18n.translate(`Observations`),
	withoutMissingData: i18n.translate(`Injured data validated!`),
	missingDataTriage: i18n.translate(`Missing data`),
}

export default class MedicalOpinion {
	static fromJSON(json) {
		const instance = new MedicalOpinion(json.id)
		instance.rawTriageValues = {
			biologicRisk: json.biologicRiskTriage,
			canTransfer: json.canTransferProcessTriage,
			hasPreviousSurgery: json.isPreviouslyPerformedSurgeryTriage,
			complexity: json.processComplexityTriage,
			duration: json.processDurationTriage,
		}
		return (
			instance
				.withProcessId(json.processId)
				.withCreationUser(json.creationUser)
				.withCreationDate(json.creationDate)
				.withResponseUser(json.responseUser)
				.withResponseDate(json.responseDate)
				.withMedicalOpinionType(json.opinionType)
				.withSubmittedMedicalOpinionRequest(
					json.submittedMedicalRequest
				)
				.withRequestedByDate()
				.withMechanismType(json.mechanismType)
				.withMechanismTypeJustification(json.mechanismTypeJustification)
				.withCausalLinkType(json.causalLinkType)
				.withCausalLinkTypeJustification(
					json.causalLinkTypeJustification
				)

				.withSuggestedActions(json.actionsJustification)
				.withMedicalOpinionResult(json.medicalOpinionResult)
				.withNameTriage(json.nameTriage)
				.withBirthdayTriage(json.birthdayTriage)
				/*CM 196 hide profession */
				// .withProfessionTriage(json.professionTriage)
				.withAccidentDateTriage(json.accidentDateTriage)
				.withIsAccidentDescriptionTriage(
					json.isAccidentDescriptionTriage
				)
				.withBodyPartTriage(json.bodyPartTriage)
				.withInjuryTriage(json.injuryTriage)
				.withBiologicRiskTriage(json.biologicRiskTriage)
				.withIsPreviouslyPerformedSurgeryTriage(
					json.isPreviouslyPerformedSurgeryTriage
				)
				.withProcessComplexityTriage(json.processComplexityTriage)
				.withProcessDurationTriage(json.processDurationTriage)
				.withCanTransferProcessTriage(json.canTransferProcessTriage)
				.withIsDiagnosisTriage(json.isDiagnosisTriage)
				.withObservationTriage(json.observationTriage)
				.withIsMedicalOpinionResolved(json)
				.withOpinionType(json)
				.withAnswers()
				.withBodyParts(json.bodyParts)
				.withAcutePhase(json.acutePhase)
		)
	}

	constructor(id) {
		this.id = id
		this.key = `medicalOpinion${id || ''}`
		this.textId = `medicalOpinion_${id || ''}`
		this.text = ''
		this.answers = []
	}

	evaluateTriageMissingData(data, label) {
		if (isNaN(data)) {
			if (data !== 'Sim' && data !== 'sim') {
				this.missingTriageData.push(label)
				return true
			}
			return false
		}
	}

	withProcessId(processId) {
		this.processId = processId?.toString(10)
		return this
	}

	withCreationUser(creationUser) {
		this.creationUser = creationUser ? parsePerson(creationUser) : null
		return this
	}

	withCreationDate(creationDate) {
		if (creationDate) {
			this.creationDate = parseDate(creationDate)
		} else {
			this.creationDate = {}
		}
		return this
	}
	/* CM 199 adding hours to card */
	withRequestedByDate() {
		this.requestedByDate = `${i18n.translate('Request by')}: ${
			this.creationUser?.name
		}, ${i18n.translate('on the date of')}: ${
			this.creationDate?.tinyDateFormat
		} ${this.creationDate?.shortTimeFormat || ''}`

		return this
	}

	withResponseUser(responseUser) {
		this.responseUser = responseUser ? parsePerson(responseUser) : null
		return this
	}

	withResponseDate(resDate) {
		if (resDate) {
			this.responseDate = parseDate(resDate)
		} else {
			this.responseDate = {}
		}
		return this
	}

	withMedicalOpinionType(opinionType) {
		this.medicalObservationType = opinionType
		this.typeCode = medicalOpinionTypeParse(opinionType)
		return this
	}

	withSubmittedMedicalOpinionRequest(submittedMedicalRequest) {
		this.submittedMedicalRequest = submittedMedicalRequest
		this.text = `${submittedMedicalRequest}`
		return this
	}

	withMechanismType(mechanismType) {
		this.mechanismType = mechanismType
		return this
	}

	withMechanismTypeJustification(mechanismTypeJustification) {
		this.mechanismTypeJustification = mechanismTypeJustification
		return this
	}

	withCausalLinkType(causalLinkType) {
		this.causalLinkType = causalLinkType
		return this
	}

	withCausalLinkTypeJustification(causalLinkTypeJustification) {
		this.causalLinkTypeJustification = causalLinkTypeJustification
		return this
	}

	withSuggestedActions(actionsJustification) {
		this.actions = actionsJustification
		return this
	}

	withMedicalOpinionResult(medicalOpinionResult) {
		this.medicalOpinionResult = medicalOpinionResult
		return this
	}

	withNameTriage(nameTriage) {
		this.nameTriage = nameTriage
		return this
	}

	withBirthdayTriage(birthdayTriage) {
		this.birthdayTriage = birthdayTriage
		return this
	}

	withProfessionTriage(professionTriage) {
		this.professionTriage = professionTriage
		return this
	}

	withAccidentDateTriage(accidentDateTriage) {
		this.accidentDateTriage = accidentDateTriage
		return this
	}

	withIsAccidentDescriptionTriage(isAccidentDescriptionTriage) {
		this.isAccidentDescriptionTriage = isAccidentDescriptionTriage
		return this
	}

	withBodyPartTriage(bodyPartTriage) {
		this.bodyPartTriage = bodyPartTriage
		return this
	}

	withInjuryTriage(injuryTriage) {
		this.injuryTriage = injuryTriage
		return this
	}

	withBiologicRiskTriage(biologicRiskTriage) {
		this.biologicRiskTriage = biologicRiskTriage
		return this
	}

	withIsPreviouslyPerformedSurgeryTriage(isPreviouslyPerformedSurgeryTriage) {
		this.isPreviouslyPerformedSurgeryTriage =
			isPreviouslyPerformedSurgeryTriage ? i18n`Yes` : i18n`No`
		return this
	}

	withProcessComplexityTriage(processComplexityTriage) {
		this.processComplexityTriage = processComplexityTriage
		return this
	}

	withProcessDurationTriage(processDurationTriage) {
		this.processDurationTriage = processDurationTriage
		return this
	}

	withCanTransferProcessTriage(canTransferProcessTriage) {
		this.canTransferProcessTriage = canTransferProcessTriage
			? i18n`Yes`
			: i18n`No`
		return this
	}

	withIsDiagnosisTriage(isDiagnosisTriage) {
		this.isDiagnosisTriage =
			isDiagnosisTriage !== null
				? isDiagnosisTriage
					? i18n`Yes`
					: i18n`No`
				: i18n`Not defined`
		return this
	}

	withObservationTriage(observationTriage) {
		this.observationTriage = observationTriage
		return this
	}

	withIsMedicalOpinionResolved(json) {
		this.isMedicalOpinionResolved = !!(
			json.medicalOpinionResult &&
			json.medicalOpinionResult !== '' &&
			json.responseUser
		)

		return this
	}

	withOpinionType(json) {
		this.opinionType = json.opinionType
		return this
	}

	withAnswers() {
		switch (this.medicalObservationType) {
			case 'Triagem':
				this.missingTriageData = []

				if (this.nameTriage) {
					this.evaluateTriageMissingData(
						this.nameTriage,
						questionLabels.nameTriage
					)
				}

				if (this.birthdayTriage) {
					this.evaluateTriageMissingData(
						this.birthdayTriage,
						questionLabels.birthdayTriage
					)
				}
				/*CM 196 hide profession */
				// if (this.professionTriage) {
				// 	this.evaluateTriageMissingData(
				// 		this.professionTriage,
				// 		questionLabels.professionTriage
				// 	)
				// }

				if (this.accidentDateTriage) {
					this.evaluateTriageMissingData(
						this.accidentDateTriage,
						questionLabels.accidentDateTriage
					)
				}

				if (this.isAccidentDescriptionTriage) {
					this.evaluateTriageMissingData(
						this.isAccidentDescriptionTriage,
						questionLabels.isAccidentDescriptionTriage
					)
				}

				if (this.missingTriageData.length === 0) {
					this.missingTriageData = {
						label: null,
						answer: questionLabels.withoutMissingData,
						isMissing: true,
					}
				} else {
					this.missingTriageData = {
						label: questionLabels.missingDataTriage,
						answer: (this.missingTriageData =
							this.missingTriageData.join(', ')),
						isMissing: false,
					}
				}

				this.biologicRiskTriage = {
					shortLabel: questionLabels.biologicRiskTriageShort,
					question: questionLabels.biologicRiskTriage,
					answer: this.biologicRiskTriage ? i18n`Yes` : i18n`No`,
				}

				this.bodyPartTriage = {
					question: questionLabels.bodyPartTriage,
					answer: this.bodyPartTriage || i18n`Not defined`,
				}

				this.injuryTriage = {
					question: questionLabels.injuryTriage,
					answer: this.injuryTriage || i18n`Not defined`,
				}

				this.isPreviouslyPerformedSurgeryTriage = {
					shortLabel:
						questionLabels.isPreviouslyPerformedSurgeryTriageShort,
					question: questionLabels.isPreviouslyPerformedSurgeryTriage,
					answer:
						this.isPreviouslyPerformedSurgeryTriage ||
						i18n`Not defined`,
				}

				this.processComplexityTriage = {
					question: questionLabels.processComplexityTriage,
					answer: this.processComplexityTriage || i18n`Not defined`,
				}

				this.processDurationTriage = {
					question: questionLabels.processDurationTriage,
					answer: this.processDurationTriage || i18n`Not defined`,
				}

				this.canTransferProcessTriage = {
					question: questionLabels.canTransferProcessTriage,
					answer: this.canTransferProcessTriage || i18n`Not defined`,
				}

				this.mechanism = {
					shortLabel: questionLabels.mechanismShort,
					question: questionLabels.mechanism,
					answer: this.mechanismType || i18n`Not defined`,
				}

				this.diagnosisTriage = {
					shortLabel: questionLabels.diagnosisTriageShort,
					question: questionLabels.diagnosisTriage,
					answer: this.isDiagnosisTriage || i18n`Not defined`,
				}

				this.diagnosesWithCausalLinkMechanism = {
					shortLabel:
						questionLabels.isPerformedDiagnosisWithCausalLinkTriageShort,
					question:
						questionLabels.isPerformedDiagnosisWithCausalLinkTriage,

					answer: this.causalLinkType || i18n`Not defined`,
				}

				this.observationTriage = {
					question: questionLabels.observationTriage,
					answer: this.observationTriage || i18n`Not defined`,
				}
				this.text = `${this.text}\n${questionLabels.observationTriage}\n${this.observationTriage.answer}`

				break

			case 'Avaliação de Nexo Causal':
				if (this.mechanismType) {
					this.answers.push({
						question: questionLabels.mechanism,
						answer: this.mechanismType,
					})
					this.text = `${this.text}\n${questionLabels.mechanism}\n${this.mechanismType}`
				}

				if (this.mechanismTypeJustification) {
					this.answers.push({
						question: questionLabels.justification,
						answer: this.mechanismTypeJustification,
					})
					this.text = `${this.text}\n${questionLabels.justification}\n${this.mechanismTypeJustification}`
				}

				if (this.causalLinkType) {
					this.answers.push({
						question: questionLabels.isDiagnosis,
						answer: this.causalLinkType,
					})
					this.text = `${this.text}\n${questionLabels.isDiagnosis}\n${this.causalLinkType}`
				}

				if (this.causalLinkTypeJustification) {
					this.answers.push({
						question: questionLabels.justification,
						answer: this.causalLinkTypeJustification,
					})
					this.text = `${this.text}\n${questionLabels.justification}\n${this.causalLinkTypeJustification}`
				}

				if (this.actions) {
					this.answers.push({
						question: questionLabels.isSuggestedActions,
						answer: this.actions,
					})
					this.text = `${this.text}\n${questionLabels.isSuggestedActions}\n${this.actions}`
				}

				if (this.medicalOpinionResult) {
					this.answers.push({
						question: questionLabels.medicalOpinionResult,
						answer: this.medicalOpinionResult,
					})
					this.text = `${this.text}\n${questionLabels.medicalOpinionResult}\n${this.medicalOpinionResult}`
				}
				break

			default:
				if (this.medicalOpinionResult) {
					this.answers.push({
						question: questionLabels.medicalOpinionResult,
						answer: this.medicalOpinionResult,
					})
					this.text = `${this.text}\n${questionLabels.medicalOpinionResult}\n${this.medicalOpinionResult}`
				}
		}

		return this
	}

	withBodyParts(bodyParts) {
		this.bodyParts = bodyParts
		return this
	}

	withAcutePhase(acutePhase) {
		this.acutePhase = acutePhase
		return this
	}
}
